// Memorial entry for Tamir Adar
import tamirAdarPortrait from '../../../images/tamir-adar.jpg';

export const tamirAdarMemorial = {
  id: 28,
  name: 'Tamir Adar',
  images: {
    portrait: tamirAdarPortrait
  },
  info: `
"Don't open the door for anyone, even if it's me asking you to." - Tamir's final words to his wife Hadas

# Tamir Adar

![Tamir Adar](${tamirAdarPortrait})
*Tamir Adar, 38, third-generation kibbutznik and protector of Nir Oz*

## Born to Nir Oz

Tamir Adar was the first grandson born in Kibbutz Nir Oz - a third-generation kibbutznik whose roots ran as deep as the community itself. At 38 years old, he had fulfilled his lifelong dream of working the land, managing the kibbutz's water department while his father Moshe grew peanuts nearby. Father and son worked side by side in the fields.

He was married to Hadas and father to Asaf (7) and Neta (3). A sign on his door read: "There is no grumbling here — we just say thank you and charge ahead with life."

## A Man of Many Passions

Tamir was a devoted family man who loved nature and people. Friends described him as "a person of dialogue, possessing broad knowledge about nearly every topic" and "sociable and beloved, a thoughtful and sensitive conversationalist with a keen sense of humor."

He was a passionate Maccabi Tel Aviv supporter, loved the music of Meir Ariel, and would observe birds of prey with binoculars while working the fields. He often took his young children hiking to watch the sunset.

Before returning to agriculture, Tamir worked as a social leader at a local school for the Ramon Foundation, established in memory of Israeli astronaut Ilan Ramon. They described him as "a role model and source of inspiration."

## The Last Stand

On October 7, 2023, Tamir served as deputy security coordinator of Kibbutz Nir Oz. At 6:30 a.m., when the alert came that hundreds of terrorists had infiltrated, he left his house immediately. Before going, he instructed Hadas and their children to stay in the safe room, speaking the haunting final words: "Don't open the door for anyone, even if it's me asking you to."

He knew what he was facing. As a member of the emergency response squad, he had trained for this moment - though the training always assumed the army would arrive in time. It didn't.

Tamir fought alongside his fellow squad members against overwhelming odds. According to a security volunteer: "He fought to the last bullet. Tamir didn't run. He stood his ground."

He was mortally wounded in the battle. His body was taken to Gaza.

His wife and children survived because of his protection.

## 746 Days

For 91 days, Tamir's family didn't know if he was dead or alive. On January 5, 2024, the IDF confirmed he had been killed on October 7.

On October 21, 2025 - 746 days after his abduction - Tamir's remains were returned to Israel alongside those of Aryeh Zalmanovich, the 86-year-old founder of Nir Oz. One man built the kibbutz; the other gave his life defending it.

## Coming Home

Over 1,000 people attended Tamir's funeral on October 23, 2025. President Isaac Herzog asked for forgiveness: "Forgive us that you and your comrades in the security squad were left alone to face those human monsters."

His father Moshe spoke through tears: "My beloved Tamiri, you have finally come home, to the place where you were born, grew up, and started your family. To the place you defended with supreme courage until you could fight no more. You are a hero, a true hero."

His mother Yael added: "You're free, at home. You're here now, on the grass where you used to run around, beside the tree you used to climb."

Tamir was posthumously recognized as a fallen soldier with the rank of Staff Sergeant Major in the reserves.

*For us, we act first and ask questions later. May his memory be a blessing.*

[Read more about Tamir Adar](https://www.timesofisrael.com/sorry-tamiri-family-of-slain-hostage-tamir-adar-bids-him-farewell-at-nir-oz-funeral/)
`
};
